"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileProfile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const profile_module_scss_1 = __importDefault(require("./profile.module.scss"));
const avatar_1 = require("primereact/avatar");
const button_1 = require("primereact/button");
const AuthContext_1 = require("../../../hooks/auth/context/AuthContext");
const MobileProfile = () => {
    const { userInfo, isLoading, logout } = (0, AuthContext_1.useAuth)();
    if (isLoading)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: profile_module_scss_1.default.container, children: [(0, jsx_runtime_1.jsxs)("div", { className: profile_module_scss_1.default.avatarContainer, children: [(0, jsx_runtime_1.jsx)(avatar_1.Avatar, { icon: "pi pi-user", shape: "circle", size: "xlarge", className: profile_module_scss_1.default.avatar, onImageError: (e) => {
                            ;
                            e.target.src = '';
                        } }), (0, jsx_runtime_1.jsx)("div", { className: profile_module_scss_1.default.textUserContainer, children: (0, jsx_runtime_1.jsx)("span", { className: profile_module_scss_1.default.textUser, children: userInfo?.username }) })] }), (0, jsx_runtime_1.jsx)("div", { className: profile_module_scss_1.default.logoutContainer, children: (0, jsx_runtime_1.jsxs)(button_1.Button, { className: profile_module_scss_1.default.logoutButton, onClick: logout, children: [' ', (0, jsx_runtime_1.jsx)("span", { className: "pi pi-sign-out text-2xl" })] }) })] }));
};
exports.MobileProfile = MobileProfile;
